<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ThirdPartyPaymentEmailDisplay',
  props: {
    email: { required: true, type: String },
    provider: { required: true, type: String },
  },
  setup() {
    return {};
  },
});
</script>

<template>
  <span class="mr-2 text-sm font-normal md:text-base">
    <b
      class="mr-1 text-sm md:mr-2 md:text-base"
      :class="{ 'hidden lg:inline-flex lg:visible': email.length > 30 }"
    >
      {{ provider }}
    </b>
    {{
      email.length > 30 // eslint-disable-next-line max-len
        ? `${email.split('@')[0].substring(0, 5)}...@${email.split('@')[1]}`
        : email
    }}
  </span>
</template>
